import { Container, styled } from '@mui/material'
import Iconfont from 'components/Iconfont'
import SimpleHead from 'components/PageNotFound/SimpleHead'
import { memo, ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { FlexColumn } from 'styles'
import { COMMUNITY_LINKS } from '../../constants/community'

const Wrap = styled(Container)`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
`
const ErrorTitle = styled('h3')`
  font-weight: 400;
  font-size: 82px;
  color: ${({ theme }) => theme.color.text100};
  margin: 0;
`
const ErrorMessage = styled('p')`
  font-weight: 500;
  font-size: 24px;
  color: ${({ theme }) => theme.color.text90};
  margin: 40px 0;
`
const ErrorStack = styled('div')`
  padding: 24px;
  margin: 0 0 24px;
  background: ${({ theme }) => theme.color.bgLightGray};
`
const LinkToHomepage = styled(Link)`
  border: 1px solid #a0ee09;
  border-radius: 6px;
  font-weight: 400;
  font-size: 16px;
  color: ${({ theme }) => theme.color.primary30};
  padding: 6px 8px;
`
const CommunityLinkGroup = styled('div')`
  display: flex;
  width: 190px;
  margin: 18px auto;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0;
`
const CommunityLink = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background: ${({ theme }) => theme.color.text10};
  border-radius: 4px;
  color: ${({ theme }) => theme.color.text40};
`

const Body = styled(FlexColumn)`
  flex: 1;
  justify-content: center;
  align-items: center;
`

const list = [
  {
    icon: 'icon-Twitter',
    link: COMMUNITY_LINKS.TWITTER,
  },
  {
    icon: 'icon-Discord1',
    link: COMMUNITY_LINKS.DISCORD,
  },
  {
    icon: 'icon-Telegram',
    link: COMMUNITY_LINKS.TELEGRAM,
  },
  {
    icon: 'icon-Medium',
    link: COMMUNITY_LINKS.MEDIUM,
  },
]

const PAGE_ERROR_CODES = {
  404: 'Error 404: Page Not Found',
  500: 'Error 500: An unexpected error occurred. Please refresh the page and try again later.',
} as const

export const PageNotFound = memo<{
  error: keyof typeof PAGE_ERROR_CODES | string
  errorStack?: ReactNode
}>(({ error, errorStack }) => {
  let message: string
  if (typeof error !== 'string') {
    message = PAGE_ERROR_CODES[error]
  } else {
    message = error
  }
  return (
    <Wrap>
      <SimpleHead></SimpleHead>
      <Body>
        <ErrorTitle>OOPS!</ErrorTitle>
        <ErrorMessage>{message}</ErrorMessage>
        {errorStack ? <ErrorStack>{errorStack}</ErrorStack> : null}
        <LinkToHomepage to="/">GO TO HOMEPAGE</LinkToHomepage>
        <CommunityLinkGroup>
          {list.map((item) => (
            <CommunityLink key={item.link} to={item.link} target={'_black'}>
              <Iconfont name={item.icon} size={20}></Iconfont>
            </CommunityLink>
          ))}
        </CommunityLinkGroup>
      </Body>
    </Wrap>
  )
})
